// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7145e664","977":"61fc1e05"}[chunkId] + ".chunk.js";
};